import React from "react";

function strip(html) 
    {  
        if (html && html !== ''){
            html = html?.toString() || html;
    }
    else{
        return html;
    }
    return html?.replace( /(<([^>]+)>)/ig, '') || html;
    }

function checkText(text){
        var urlRegex = /[a-zA-Z0-9\\+\\.\\_\\%\\-]{1,256}\\@[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}(\\.[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25})+/gi;
        var urlRegex = /(((https?:\/\/)|(http?:\/\/)|(www\.)|(\.com)|(\.ru)|(\.net))|(\.mobi)|(\.org)|(\.de)[^\s]+)/gi;
        let lvl1= text?.replace(urlRegex, function(url) {
            return '*****';
        });
        return lvl1?.replace(urlRegex, function(url) {
            return '*****';
        });
}
function checkLink(e){
    //here you would want to use a regular expression and check for http:

    var regularExpression = !!checkText(e.target.innerHTML); // returns true or false
    if(regularExpression){
      e.target.innerHTML += `<a href='#'><img src="" alt="" /></a>`;
    }
}


export {
    checkLink,
    checkText,
    strip
}